import {
  sliderImg2,
  sliderImg3,
  sliderImg4,
  sliderImg5,
  sliderImg6,
} from "../../../assets/img";

const communityData = [
  {
    username: "john_doe",
    bio: "A passionate developer and tech enthusiast.",
    paragraph:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce luctus pretium fermentum. Etiam sit amet augue vel elit finibus. Duis non sem at sapien.",
    image: sliderImg2,
  },
  {
    username: "jane_smith",
    bio: "UI/UX designer with a love for creativity.",
    paragraph:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta at, veniam dolorum doloribus animi amet exercitationem ea perspiciatis aperiam error voluptas vero ut nulla sit, possimus magnam qui suscipit! Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Integer sit amet justo a est fermentum pharetra ac id ligula.",
    image: sliderImg3,
  },
  {
    username: "alex_jones",
    bio: "Full-stack developer and open-source advocate.",
    paragraph:
      "Curabitur vitae turpis in est ullamcorper euismod. Proin tincidunt nisi nec justo cursus, non fermentum mi gravida. Phasellus dapibus vel est.",
    image: sliderImg4,
  },
  {
    username: "maria_gonzalez",
    bio: "Data scientist with a knack for numbers.",
    paragraph:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta at, veniam dolorum doloribus animi amet exercitationem ea perspiciatis aperiam error voluptas vero ut nulla sit, possimus magnam qui suscipit!Suspendisse potenti. Curabitur sit amet vestibulum ipsum, vel gravida arcu. Quisque condimentum vehicula scelerisque. Aliquam erat volutpat. Sed cursus dapibus velit.",
    image: sliderImg5,
  },
  {
    username: "david_wilson",
    bio: "Cloud architect focused on scalable solutions.",
    paragraph:
      "Ut volutpat, libero non vehicula bibendum, tortor eros porttitor sapien, vitae suscipit ipsum nisi sed ligula. Proin sed posuere nulla, vitae sodales ex.",
    image: sliderImg6,
  },
  {
    username: "sarah_lee",
    bio: "Mobile app developer with a love for Android and iOS.",
    paragraph:
      "Mauris non risus urna. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut consequat purus id sem.",
    image: sliderImg2,
  },
  {
    username: "michael_brown",
    bio: "DevOps engineer specializing in CI/CD pipelines.",
    paragraph:
      "Donec non ligula nunc. Sed elementum vulputate odio at interdum. In quis arcu id sem laoreet efficitur in nec risus. Vivamus nec vulputate.",
    image: sliderImg3,
  },
  {
    username: "emma_white",
    bio: "Front-end developer and CSS wizard.",
    paragraph:
      "Proin bibendum arcu ac convallis ullamcorper. Sed elementum viverra mauris id posuere. Aliquam ultricies velit et purus congue, in vulputate purus viverra.",
    image: sliderImg4,
  },
  {
    username: "oliver_martin",
    bio: "Machine learning engineer and AI enthusiast.",
    paragraph:
      "Morbi ultricies velit a justo tempus sagittis. Nulla facilisi. In euismod varius risus, in suscipit mi scelerisque eget. Vivamus eget leo vitae lacus.",
    image: sliderImg5,
  },
  {
    username: "sophia_thompson",
    bio: "Backend developer with expertise in Python and Node.js.",
    paragraph:
      "Etiam eget justo est. Duis ut lorem vel purus cursus consectetur. Nulla fermentum velit non urna tristique, vitae luctus orci sagittis. Suspendisse a ornare.",
    image: sliderImg6,
  },
  {
    username: "liam_clark",
    bio: "SLorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta at, veniam dolorum doloribus animi amet exercitationem ea perspiciatis aperiam error voluptas vero ut nulla sit, possimus magnam qui suscipit!ecurity specialist with a focus on ethical hacking.",
    paragraph:
      "Sed faucibus dolor nec varius pharetra. Sed eu dui magna. Nulla nec lorem neque. Aliquam tincidunt turpis non turpis pharetra, quis interdum nisl.",
    image: sliderImg2,
  },
  {
    username: "mia_roberts",
    bio: "Blockchain developer working on decentralized applications.",
    paragraph:
      "Fusce luctus vestibulum justo, sit amet malesuada sapien bibendum non. Sed dignissim, urna eu facilisis porttitor, lectus velit dictum orci, nec accumsan.",
    image: sliderImg3,
  },
  {
    username: "lucas_walker",
    bio: "Game developer with experience in Unity and Unreal Engine.",
    paragraph:
      "Nullam interdum ante metus, ut fermentum odio rhoncus ut. Mauris ut semper ipsum, ut dictum est. Integer convallis nisl in lacus tincidunt aliquam.",
    image: sliderImg4,
  },
  {
    username: "amelia_hall",
    bio: "SEO expert helping businesses grow online.",
    paragraph:
      "Donec tincidunt, nisl eget pretium suscipit, neque purus tempor libero, id varius elit est sit amet orci. Suspendisse potenti. Nulla facilisi.",
    image: sliderImg5,
  },
  {
    username: "noah_turner",
    bio: "Product manager with a love for agile methodologies.",
    paragraph:
      "Phasellus et magna a velit vehicula feugiat. Vivamus euismod ligula eu tortor varius, a venenatis justo vestibulum. In non vulputate mi.",
    image: sliderImg6,
  },
  {
    username: "harper_scott",
    bio: "Content writer and digital marketing strategist.",
    paragraph:
      "Suspendisse id lacus a elit rhoncus suscipit. Mauris at augue vel risus tristique feugiat id vel orci. In hac habitasse platea dictumst. Integer.",
    image: sliderImg2,
  },
  {
    username: "jack_king",
    bio: "Creative director and branding expert.",
    paragraph:
      "Quisque facilisis massa at odio fermentum, ut tincidunt neque faucibus. Sed sagittis magna ut enim lobortis, in dictum lacus aliquet. Integer.",
    image: sliderImg3,
  },
  {
    username: "ella_cooper",
    bio: "Photographer capturing moments and stories.",
    paragraph:
      "Vestibulum fringilla augue non convallis ullamcorper. Nunc ornare, mi sit amet luctus pellentesque, justo elit ullamcorper ligula, sed convallis nisi neque.",
    image: sliderImg4,
  },
  {
    username: "henry_bell",
    bio: "AI researcher passionate about the future of technology.",
    paragraph:
      "Vivamus rhoncus nisl a leo vehicula, quis dapibus metus ultricies. Proin interdum neque ut massa tincidunt, nec congue enim egestas. Fusce fringilla.",
    image: sliderImg5,
  },
  {
    username: "charlotte_edwards",
    bio: "Environmental advocate and sustainable living blogger.",
    paragraph:
      "Etiam tincidunt velit nec justo accumsan, in facilisis leo dapibus. In lobortis libero non velit fermentum tempor. Aenean eget justo elit.",
    image: sliderImg6,
  },
  {
    username: "william_taylor",
    bio: "JavaScript developer and React enthusiast.",
    paragraph:
      "Nulla sit amet lectus in sapien pharetra gravida ut id nisi. Sed sit amet urna velit. Nulla congue, dui sed interdum tincidunt, eros sem.",
    image: sliderImg2,
  },
  {
    username: "grace_wright",
    bio: "Freelance graphic designer creating impactful visuals.",
    paragraph:
      "Curabitur a lorem at tortor gravida feugiat ac quis libero. Vestibulum accumsan, lectus at fringilla fermentum, urna arcu luctus est, nec pharetra.",
    image: sliderImg3,
  },
  {
    username: "james_anderson",
    bio: "Tech entrepreneur and startup mentor.",
    paragraph:
      "Mauris tempus mauris sit amet elit ultricies efficitur. Phasellus id ultricies justo. Nunc malesuada, felis eget ullamcorper euismod, erat urna euismod lacus.",
    image: sliderImg4,
  },
  {
    username: "ava_hughes",
    bio: "Fitness coach and wellness advocate.",
    paragraph:
      "Sed accumsan, magna et tincidunt vestibulum, orci libero facilisis erat, sed facilisis ligula purus nec nunc. Nullam ultricies viverra mi. Nulla facilisi.",
    image: sliderImg5,
  },
  {
    username: "benjamin_moore",
    bio: "Web developer focused on accessibility and performance.",
    paragraph:
      "Integer consectetur odio nec felis pharetra, et molestie felis gravida. Curabitur interdum convallis sapien, in tempus leo vehicula nec. Morbi.",
    image: sliderImg6,
  },
  {
    username: "lily_jackson",
    bio: "Fashion designer exploring sustainable fashion.",
    paragraph:
      "Suspendisse in arcu vitae erat vehicula fermentum vel id est. Praesent suscipit ligula vel sapien facilisis, et cursus nulla egestas.",
    image: sliderImg2,
  },
  {
    username: "daniel_green",
    bio: "Mobile game developer creating fun experiences.",
    paragraph:
      "Nullam scelerisque lacus eget risus faucibus, ac eleifend elit cursus. Duis interdum ex sit amet libero efficitur, ac aliquet tortor congue.",
    image: sliderImg3,
  },
  {
    username: "zoe_clark",
    bio: "Tech writer covering software and gadgets.",
    paragraph:
      "Vivamus aliquet lorem non nisl dignissim, a pharetra urna feugiat. Curabitur vulputate scelerisque libero, vel rutrum ex tincidunt eu. Donec.",
    image: sliderImg4,
  },
  {
    username: "ethan_mitchell",
    bio: "Cloud-native developer and DevOps advocate.",
    paragraph:
      "Phasellus id ipsum ac nulla iaculis hendrerit. Ut commodo turpis nec leo viverra, nec lacinia arcu pharetra. Etiam scelerisque luctus interdum.",
    image: sliderImg5,
  },
  {
    username: "scarlett_martinez",
    bio: "Journalist writing about global events and news.",
    paragraph:
      "Mauris id arcu eget odio ultricies tincidunt sit amet eget tortor. Fusce pretium dui a erat ullamcorper, quis pharetra ex sodales. Cras.",
    image: sliderImg6,
  },
];

export default communityData;
